import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/Listing/Listing.styles';
import SingleImage from '@features/cms/components/categories/CategoryGalleryBlock/components/SingleImage/SingleImage';
import { ICategoryGalleryBlockImage } from '@features/cms/typescript';
type PropsType = {
  images: ICategoryGalleryBlockImage[][];
};
const ListingMobile = ({
  images
}: PropsType) => {
  const imagesArray = images.flat();
  const processedImages: (ICategoryGalleryBlockImage | ICategoryGalleryBlockImage[])[] = [];
  let currentIndex = 0;
  while (currentIndex < imagesArray.length) {
    const currentImage = imagesArray[currentIndex];
    const nextImage = currentIndex + 1 < imagesArray.length ? imagesArray[currentIndex + 1] : null;
    if (currentImage.orientation === 'vertical' && nextImage && nextImage.orientation === 'vertical') {
      processedImages.push([currentImage, nextImage]);
      currentIndex += 2;
    } else {
      processedImages.push(currentImage);
      currentIndex += 1;
    }
  }
  return <div sx={styles.imagesContainer}>
      <div sx={styles.mobileImageContainer}>
        {processedImages.map((item, index) => {
        if (Array.isArray(item)) {
          return <div key={`vertical_pair_${index}`} sx={styles.mobileVerticalImagesRow}>
                {item.map(image => <div sx={styles.image} key={image.image.path}>
                    <SingleImage image={image} />
                  </div>)}
              </div>;
        }
        return <div key={`single_image_${index}`} sx={styles.mobileImageItem}>
              <div sx={styles.image}>
                <SingleImage image={item} />
              </div>
            </div>;
      })}
      </div>
    </div>;
};
export default ListingMobile;